import './App.css';
import './vendor/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { ArcaneLab } from "./components/ArcaneLab";
import { Footer } from "./components/Footer";
import { usePreventDevTools } from './components/usePreventDevTools';
function App() {
  usePreventDevTools();
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <ArcaneLab />
      <Footer />
    </div>
  );
}

export default App;
